<template>
    <div class="view24Wrapper">
        <CrossSlip v-if="type==='activity'">
            <ContentCard v-for="(item,ix) in list" :data="item" @to-get="handleGet(item.id)" @on-click="()=>onAsk(item.id, type, {cover: item.cover, imageAlbum: item.imageAlbum, address: item.address, title: item.title, startTime: item.startTime, endTime: item.endTime, detail: item.detail})" :key="`content-card-${ix}`"/>
        </CrossSlip>

        <CrossSlip  v-else-if="type==='movie'">
            <BaseCard v-for="(item,ix) in list" :imgUrl="item.cover" :name="item.title" :star="item.rate" cardType="movie" @on-click="()=>onAsk(item.id, type, {cover: item.cover, title: item.title, rate: item.rate, director: item.director, actor: item.actor, kind: item.kind, detail: item.detail})" :key="`movie-card-${ix}`"/>
        </CrossSlip>
    </div>
</template>

<script>
    import CrossSlip from '../Use/cross-slip-wrapper'
    import ContentCard from '@/components/Use/content-card'
    import BaseCard from '@/components/Use/base-card'
    export default {
        name: "View24",
        components: {CrossSlip, ContentCard, BaseCard},
        props: {
            list: {
                type: Array,
                default: ()=>[]
            },
            type:{
                type: String,
                default: ''
            }
        },
        methods: {
            onAsk(id, type, info){
                switch (type) {
                    case 'activity': {
                        this.$emit("on-show",id, info, 11, 'white')
                    }
                    break
                    case 'movie': {
                        this.$emit("on-show",id, info, 12, 'white')
                    }
                    break
                    default: {

                    }
                    break
                }
            },
            handleGet(id){
                this.$emit("on-share", 31,id)
            }
        }
    }
</script>

<style scoped lang="less">
    .view24Wrapper{

    }

</style>
